/**
 * Discovery by intent: what a visitor is in the mood for, not what genre a
 * marketer filed it under.
 *
 * A mood is only ever attached to a game that honestly fits it, so a mood with
 * no games shows an empty state instead of a padded list.
 */

import { MOOD_IDS } from "./types.js";
import type { Mood, MoodId } from "./types.js";

export const MOODS: readonly Mood[] = [
  { id: "brain-boost", nameKey: "portal.mood.brain-boost", motif: "puzzle", accent: "grape" },
  { id: "play-together", nameKey: "portal.mood.play-together", motif: "confetti", accent: "punch" },
  { id: "quick-play", nameKey: "portal.mood.quick-play", motif: "bolt", accent: "flame" },
  { id: "relax", nameKey: "portal.mood.relax", motif: "wave", accent: "lagoon" },
  { id: "challenge", nameKey: "portal.mood.challenge", motif: "flag", accent: "berry" },
  {
    id: "learn-through-play",
    nameKey: "portal.mood.learn-through-play",
    motif: "flask",
    accent: "sky",
  },
  {
    id: "timeless-classics",
    nameKey: "portal.mood.timeless-classics",
    motif: "cards",
    accent: "apricot",
  },
  { id: "new-on-kikik", nameKey: "portal.mood.new-on-kikik", motif: "arcade", accent: "jade" },
];

const BY_ID = new Map<MoodId, Mood>(MOODS.map((mood) => [mood.id, mood]));

export function getMood(id: string): Mood | null {
  return BY_ID.get(id as MoodId) ?? null;
}

export function isMoodId(value: unknown): value is MoodId {
  return typeof value === "string" && (MOOD_IDS as readonly string[]).includes(value);
}
